import { mapKeys } from 'lodash-es';
import {
  DATE_FORMATS,
  DATE_SEPARATORS,
  DATETIME_SEPARATORS,
  TIME_FORMATS,
  TIME_SEPARATORS
} from '../constants';
import {
  getStoredTranslationsKeysVisible,
  removeStoredTranslationsKeysVisible,
  setStoredTranslationsKeysVisible
} from './storedLanguageTranslation';

export const getBrowserLanguage = () => window.navigator.language;

export const checkAndSaveTranslationKeysVisible = () => {
  const urlParams = new URLSearchParams(window.location.search);
  const keyFromContentManager = urlParams.get('translate');

  if (keyFromContentManager) {
    if (keyFromContentManager === 'disable') {
      setStoredTranslationsKeysVisible();
    }
    if (keyFromContentManager === 'enable') {
      removeStoredTranslationsKeysVisible();
    }
  }
};

export const initAndGetIsShowTranslationKeys = () => {
  checkAndSaveTranslationKeysVisible();

  return getStoredTranslationsKeysVisible();
};

export const convertTranslationsToLowerCase = (translations) =>
  mapKeys(translations, (_, key) => key.toLowerCase());

export const detectFormat = (strDateTime = '') => {
  console.warn('please, use "format" props for parse your specific format');
  if (/^[\d]+$/.test(strDateTime.toString())) {
    return '';
  }
  let dateTimeSeparator = '';
  let parsedDate = [strDateTime];
  for (const separator of DATETIME_SEPARATORS) {
    if (strDateTime.split(separator).length === 2) {
      dateTimeSeparator = separator;
      parsedDate = strDateTime.split(separator);
    }
  }
  const [date = '', time = ''] = parsedDate;
  let dateFormat = '';
  let timeFormat = '';
  for (const [format, regExp] of Object.entries(DATE_FORMATS)) {
    if (regExp.test(date)) {
      let separator = '';
      for (const dateSeparator of DATE_SEPARATORS) {
        if (date.split(dateSeparator).length > 1) {
          separator = dateSeparator;
        }
      }
      dateFormat = format.split('_').join(separator);
    }
  }
  for (const [format, regExp] of Object.entries(TIME_FORMATS)) {
    if (regExp.test(time)) {
      let separator = '';
      for (const timeSeparator of TIME_SEPARATORS) {
        if (time.split(timeSeparator).length > 1) {
          separator = timeSeparator;
        }
      }
      timeFormat = format.split('_').join(separator);
    }
  }

  return dateTimeSeparator && !timeFormat
    ? ''
    : `${dateFormat}${dateTimeSeparator}${timeFormat}`;
};
